import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Button } from './ui/button';

const Header = () => {
  const { currentLanguage, changeLanguage, t } = useLanguage();

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <header className="navigation-header">
      <a href="#" className="navigation-logo">
        {t.hero.name}
      </a>
      
      <nav>
        <ul className="navigation-menu">
          <li>
            <button onClick={() => scrollToSection('about')} className="navigation-link">
              {t.nav.about}
            </button>
          </li>
          <li>
            <button onClick={() => scrollToSection('services')} className="navigation-link">
              {t.nav.services}
            </button>
          </li>
          <li>
            <button onClick={() => scrollToSection('contact')} className="navigation-link">
              {t.nav.contact}
            </button>
          </li>
        </ul>
      </nav>

      <div className="navigation-utilities">
        <div className="language-switcher">
          <Button
            variant="ghost"
            size="sm"
            onClick={() => changeLanguage('ru')}
            className={currentLanguage === 'ru' ? 'language-active' : ''}
          >
            RU
          </Button>
          <Button
            variant="ghost"
            size="sm"
            onClick={() => changeLanguage('uk')}
            className={currentLanguage === 'uk' ? 'language-active' : ''}
          >
            UK
          </Button>
          <Button
            variant="ghost"
            size="sm"
            onClick={() => changeLanguage('en')}
            className={currentLanguage === 'en' ? 'language-active' : ''}
          >
            EN
          </Button>
        </div>
      </div>
    </header>
  );
};

export default Header;